import './App.css';
import Hero from './components/Hero/Hero';
import Pictures from './components/Pictures/Pictures';
import Plans from './components/Plans/Plans';
import Reasons from './components/Reasons/Reasons';
import Testimonials from './components/Testimonials/Testimonials';
import Join from './components/Join/Join';
import Footer from './components/Footer/Footer';

function App() {

  return (
    <div className="App">
          <Hero/>
          <Pictures/>
          <Reasons/>
          <Plans/>
          <Testimonials/>
          <Join/>
          <Footer/>
    </div>
  );
}

export default App;